function Regular() {
  return (
    <div className="dice-face face--regular">
      <span>
        REGULAR
        <br /> or GOOFY
      </span>
    </div>
  );
}

export default Regular;
